import request from '@/util/request';

export function indexStat(query) {
  return request({
    url: '/tran/stat/index',
    method: 'get',
    params: query
  });
}
